import { __rest } from 'tslib';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Checkbox as Checkbox$1 } from 'primereact/checkbox';
import { forwardRef } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import '../../_utils/components/InputError.module.scss.js';
import 'clsx';
import 'primereact/tooltip';
import '../../_utils/components/InputLabel.module.scss.js';
import { InputHintError } from '../../_utils/components/InputHintError.js';

function CheckboxComponent(props, ref) {
  const {
      name,
      label,
      description,
      children,
      checked,
      onChange,
      onBlur: _
    } = props,
    rest = __rest(props, ["name", "label", "description", "children", "checked", "onChange", "onBlur"]);
  const formContext = useFormContext();
  const isControlled = typeof checked === 'boolean' ? true : false;
  const checkboxContent = (field, fieldState) => {
    const inputId = rest.inputId || name || "checkbox-".concat(Math.random());
    return jsxs("div", {
      className: "flex flex-column gap-2",
      children: [jsxs("div", {
        className: "flex gap-2 ".concat(children ? 'align-items-start' : 'align-items-center'),
        children: [jsx(Checkbox$1, Object.assign({
          ref: ref,
          name: name,
          inputId: inputId,
          checked: field ? Boolean(field === null || field === void 0 ? void 0 : field.value) : Boolean(checked),
          value: field ? Boolean(field === null || field === void 0 ? void 0 : field.value) : Boolean(checked),
          onChange: e => {
            if (field) {
              field === null || field === void 0 ? void 0 : field.onChange(e);
              return;
            }
            if (onChange) {
              onChange(e);
            }
          }
        }, rest)), jsxs("label", {
          htmlFor: inputId,
          className: rest.disabled ? undefined : 'cursor-pointer',
          children: [!children ? jsxs("span", {
            children: [label, ' ', description ? jsxs(Fragment, {
              children: [jsx("br", {}), " ", description]
            }) : null]
          }) : null, children ? jsx("div", {
            children: children
          }) : null]
        })]
      }), jsx(InputHintError, {
        fieldState: fieldState
      })]
    });
  };
  if (isControlled || !formContext || !name) {
    return checkboxContent();
  }
  return jsx(Controller, {
    name: name,
    control: formContext.control,
    render: _ref => {
      let {
        field,
        fieldState
      } = _ref;
      return checkboxContent(field, fieldState);
    }
  });
}
const Checkbox = /*#__PURE__*/forwardRef(CheckboxComponent);

export { Checkbox };
